<template>
  <div class="writings">
    <div class="pb-5">
      <div class="container-fluid px-3 px-md-2">
        <ul class="menu d-flex justify-content-center">
          <li><router-link to="/articles" class="py-4">Articles</router-link></li>
          <li><router-link to="/publications" class="py-4 cur">Publications</router-link></li>
        </ul>
        <ul class="row row-cols-1 row-cols-md-2 row-cols-xxl-3 g-3 g-md-2 justify-content-center">
          <li class="col" v-for="(item,index) in publications" :key="index">
            <div class="bgA p-3 p-lg-4 h-100">
              <img :src="item" class="w-100 h-100 object-fit-contain">
            </div>
            
          </li>
        </ul>
        
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios-auth'


export default {
  name: 'Writings',
  data () {
    return {
      publications:[]
    }
  },
  created(){
    axios.get('/writing.json')
        .then( res => {
          return res.data
        })
        .then( response => {
          if(response.code == 0){
            this.publications = response.data.publications
           
          }
        })

    // console.log(this.lists)
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-body h3,.card-body p{word-wrap: break-word;word-break: break-all;}
.control{ margin-left: 1rem; margin-top: 5px; position: static; width: 50px; height: 50px; text-align: center; line-height: 50px;  display: inline-block; color: #000; font-size: 20px; background-color: #fff; border-radius: 50%;}
.control::after{ font-size: 20px;}


@media (min-width: 576px) {

}

@media (min-width: 768px) {

}

@media (min-width: 992px) {
  
}

@media (min-width: 1200px) {

}

@media (min-width: 1400px) {
}
</style>



// WEBPACK FOOTER //
// src/components/writings/Publications.vue